// src/hooks/useStore.ts
import { createContext, useContext } from "react";
import { IRootStore, rootStore } from "../models/RootStore";

const RootStoreContext = createContext<IRootStore>(rootStore);

export const useStore = () => useContext(RootStoreContext);
